import { ChallengeInterface } from 'types';
import { api } from './api';

export async function getChallenges(): Promise<ChallengeInterface[]> {
  try {
    const { data } = await api.get(`challenge`, {
      params: { orderby: 'extra.order', reverse: true },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data.filter(item => item.techniques?.includes('GT35'));
    }
  } catch {
    return [];
  }
}

/**
 * Retorna todos os challenges, inclusive inativos e ocultos.
 *
 * Usado como dicionário para resolver o nome de conquistas já obtidas: um
 * challenge desativado no Studio continua existindo no histórico do jogador,
 * então filtrar por `active`/`extra.hidden` aqui apagaria conquistas passadas.
 */
export async function getAllChallenges(): Promise<ChallengeInterface[]> {
  try {
    const { data } = await api.get(`challenge`, {
      params: { orderby: 'extra.order', reverse: true },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch {
    return [];
  }
}
